import router from './router'

// Ce
import './components/Video/Video'

// Scripts
import './scripts/navScript'

import './scripts/exclusivityBadgeScript'

import './main.scss'
// Css/scss
import './components/Nav/Nav.scss'
import './components/Price/Price.css'
import './components/ToTop/ToTop.scss'
import './components/Footer/Footer.scss'
import './components/CookieButton/CookieButton.scss'

import './components/ContactUsSection/ContactUsSection.scss'
import './components/ExclusivityBadge/ExclusivityBadge.scss'

// oxlint-disable-next-line @stylistic/keyword-spacing
import(
  /* webpackMode: "lazy" */
  /* webpackChunkName: "contactUsScript" */
  './scripts/contactUsScript'
)

// Ez nagyon ráér.
import(
  /* webpackMode: "lazy" */
  /* webpackChunkName: "visibilityScript" */
  './scripts/visibilityScript'
)

// Consent cookie majd lesz, ha lesz.
import(
  /* webpackMode: "lazy" */
  /* webpackChunkName: "cookieConsent" */
  './scripts/cookieConsent'
).then((res) => {
  res.default()
})

router.run()
